export const SET_COMPANY_NAME_SUCCESS = 'SET_COMPANY_NAME_SUCCESS';
export const SET_CONTACT_MAIL_SUCCESS = 'SET_CONTACT_MAIL_SUCCESS';
export const SET_CONTACT_DATA_SUCCESS = 'SET_CONTACT_DATA_SUCCESS';


export const sendContactMailSuccess = (data) => {
    return {
        type: SET_CONTACT_MAIL_SUCCESS,
        data: data
    }
};

export const sendContactMail = (data) => {

    return (dispatch) => {
        dispatch(sendContactMailSuccess(data));
    }
};

export const setContactDataSuccess = (payload) => {
    return {
        type: SET_CONTACT_DATA_SUCCESS,
        // field: field,
        payload: payload,
    }
};

export const setContactData = (payload) => {

    return (dispatch) => {
        dispatch(setContactDataSuccess(payload));
    }
};

export const setConfirmationEmailData = (bool) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_CONFIRMATION_EMAIL_DATA',
      data: bool
    });
  }
}